///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../collections/client-type.collection.ts"/>
///<reference path="../filter-templates/active-inactive.filter.ts"/>

module Meevo.Components.Controls.SmartMover {

    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import Dictionary = _.Dictionary;
    import IDocsAndFormsModel = Meevo.Plugins.DocsAndForms.IDocsAndFormsModel;

    export class DocsAndFormsDataTemplate extends DataTemplateBase implements IDataTemplate {
        public title: string;
        public allSelectedLabel: string;
        public totalSelectedMessage: string;

        private readonly _formsCollection: CollectionOptimizedApi<IDocsAndFormsModel>;

        get collection() {
            return this._formsCollection;
        }

        get leafCollection() {
            return this._formsCollection;
        }

        constructor(model: Dictionary<any>, properties: string[], private options: IDataTemplateOptions) {
            super(model, properties, options.criteria);

            this._formsCollection = new CollectionOptimizedApi(this.model[properties[0]], [], {
                url: 'DocsAndForms/Form',
                smartMoverHidden: () => this.smartMoverHidden,
                criteria: {
                    objectStateEnumList: [ObjectStateEnum.Active],
                    includeActive: true,
                    coSearchResultFilter: 0,
                    formTypeEnum: 10018
                }
            }, options.$scope);

            this.title = 'LABEL_DOCS_AND_FORMS';
            this.allSelectedLabel = 'LABEL_ALL_DOCS_AND_FORMS';
            this.totalSelectedMessage = 'LABEL_TOTAL_DOCS_AND_FORMS_SELECTED';

            if (options.required) {
                this.validation.push(new RequiredValidation(this._formsCollection, 'LABEL_DOCS_AND_FORMS_REQUIRED'));
            }
        }
    }
}
